
/**
 * The provide functionality for a parent component.
 * This registers the 'register' and 'unregister' method of the parent component
 * on the child components that are injected in the same namespace.
 *
 * @param namespace
 */
export function provide(namespace) {
    return {
        methods: {
            register: null,
            unregister: null,
        },

        provide() {
            return {
                [namespace]: {
                    register: this.register,
                    unregister: this.unregister,
                },
            }
        },
    }
}

/**
 * The inject functionality for a child component.
 * This enables a child component to access the 'register' and 'unregister' method
 * of the provided parent component in the same namespace.
 *
 * @param namespace
 */
export function inject(namespace) {
    return {
        inject: {
            [namespace]: {
                default: null
            }
        }
    }
}